import './style';
import App from './components/app';

if (typeof window === 'object') {
	window.WebFontConfig = {
		google: {
			families: ['Lato:300,400,700:latin-ext']
		}
	};
}

const loadFontsAsync = d => {
	const wf = d.createElement('script');

	const s = d.scripts[0];
	wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
	wf.async = true;
	s.parentNode.insertBefore(wf, s);


	const meta = d.createElement('meta');
	meta.name='viewport';
	meta.content= 'width=device-width, user-scalable=no';
	d.getElementsByTagName('head')[0].appendChild(meta);
};

if (typeof document === 'object') {
	loadFontsAsync(document);
}

export default App;
